import React from "react"
import { ChevronDown } from "react-feather"
import { Input } from "reactstrap"

export default class Dropdown extends React.Component {
  onChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange(e)
    }
  }
  render() {
    const { style = {}, customArrow, className, disabled } = this.props
    const inputStyle = {
      backgroundColor: "transparent",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.6 : 1,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      ...style,
    }
    if (customArrow) {
      inputStyle.paddingRight = 44
    }
    const wrapperStyle = {
      position: "relative",
      display: "inline-block",
      maxWidth: style.maxWidth ?? style.width,
      verticalAlign: "middle",
    }
    return (
      <div className={`tr-dropdown-wrap${className ? ` ${className}` : ""}`} style={wrapperStyle}>
        <Input
          className="tr-dropdown-select"
          style={inputStyle}
          name={this.props.name}
          type="select"
          value={this.props.value}
          onChange={this.onChange}
          disabled={disabled}
        >
          {this.props.children}
        </Input>
        {customArrow ? (
          <span className="tr-dropdown-arrow">{customArrow}</span>
        ) : (
          <ChevronDown
            style={{ position: "absolute", right: 5, top: "20%", zIndex: -1 }}
          />
        )}
      </div>
    )
  }
}
